/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import React from 'react';
import { Form, Modal, Icon, Input } from 'semantic-ui-react';
import icons from './icons';
import forEach from 'lodash/forEach';
import map from 'lodash/map';
import filter from 'lodash/filter';
import Button from '../buttons';
import _ from '../../translations';

const styles = {
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        maxWidth: '100%',
        overflowX: 'hidden',
        height: '70vh',
        maxHeight: '70vh',
        overflowY: 'auto',
        background: 'white',
        boxSizing: 'border-box',
        justifyContent: 'flex-start',
        alignContent: 'flex-start',
    },
    input: {
        width: '100%',
        marginBottom: '5px',
    },
    iconContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '120px',
        height: '100px',
        cursor: 'pointer',
        padding: '10px',
        boxSizing: 'border-box',
    },
    buttonContainer: {},
    iconSelector: {
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        height: '32px',
    },
    addIcon: {
        width: '22px',
        height: '22px',
        borderRadius: '50%',
        backgroundColor: '#0d3454',
        color: '#fff',
        lineHeight: '22px',
    },
};

const stylestag = `
	.icon-selector-item.selected {
		background: rgba(0,0,0,0.1)
	}
`;

class IconSelector extends React.Component {
    constructor(props) {
        super(props);

        this.icons = [];

        forEach(icons.categories, ({ icons }) => {
            forEach(icons, ({ id }) => {
                this.icons.push({
                    id,
                    name: id.split('_').join(' '),
                });
            });
        });

        this.state = {
            open: false,
            icons: this.icons,
            selected: props.value,
        };
    }

    onSearchChange = (e, { value }) => {
        if (value === '') {
            this.setState({ icons: this.icons });
            return;
        }

        const result = filter(this.icons, icon => {
            return icon.name.indexOf(value) >= 0;
        });
        this.setState({ icons: result });
    };

    removeIcon = () => {
        this.props.onChange(null, { name: this.props.name, value: null });
        this.setState({ open: false });
    };

    onAccept = () => {
        this.props.onChange(null, { name: this.props.name, value: this.state.selected });
        this.setState({ open: false });
    };

    onCancel = () => {
        this.setState({ open: false });
    };

    render() {
        const { value, label } = this.props;
        const { open, icons, selected } = this.state;

        return (
            <Form.Field>
                <style>{stylestag}</style>
                <Choose>
                    <When condition={value}>
                        <label>{label}</label>
                        <div onClick={() => this.setState({ open: true })} style={styles.iconSelector}>
                            <i className="material-icons">{value}</i>
                            <span>{_('Change Icon')}</span>
                        </div>
                    </When>
                    <Otherwise>
                        <label>{label}</label>
                        <div onClick={() => this.setState({ open: true })} style={styles.iconSelector}>
                            <Icon name="plus" style={styles.addIcon} />
                            <span>{_('Add icon')}</span>
                        </div>
                    </Otherwise>
                </Choose>
                <Modal open={open} closeButton>
                    <Modal.Header>{_('Select your icon')}</Modal.Header>
                    <Modal.Content>
                        <div style={styles.wrapper}>
                            <Input
                                icon="search"
                                style={styles.input}
                                onChange={this.onSearchChange}
                                placeholder="Search icon"
                            />
                            <div style={styles.container}>
                                {map(icons, ({ id, name }) => (
                                    <div
                                        className={
                                            selected === id ? 'selected icon-selector-item' : 'icon-selector-item'
                                        }
                                        style={styles.iconContainer}
                                        onClick={() => this.setState({ selected: id })}
                                    >
                                        <i className="material-icons">{id}</i>
                                        <p style={{ maxWidth: '100%' }} className="ellipsis">
                                            {name}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Modal.Content>
                    <Modal.Actions>
                        <div style={styles.buttonContainer}>
                            <Button type="accept" icon={false} onClick={this.removeIcon}>
                                {_('Remove Icon')}
                            </Button>
                            <Button type="accept" icon="cancel" onClick={this.onCancel}>
                                {_('Cancel')}
                            </Button>
                            <Button type="accept" icon="check" onClick={this.onAccept}>
                                {_('Accept')}
                            </Button>
                        </div>
                    </Modal.Actions>
                </Modal>
            </Form.Field>
        );
    }
}

export default IconSelector;
